import React from 'react';

import Base from './Base';

const ProClubHeader = props => {
    const title = 'Provide payment for your Pro club';
    const subText = 'Enter payment detail below.';
    return (
        <Base title={title} subText={subText} {...props} />
    );
};

export default ProClubHeader;
